import React from 'react';
import TechArtReel from '../Posts/TechArtReel';
import PortfolioPage from '../PortfolioPage';

const TechnicalArtPortfolio = (props) => {
    return (
        <PortfolioPage {...props} id="TechArt" title={`Projects`} subtitle={'Projects where I made VFX, tools or optimizations!'} list={'technical art'} >
            <TechArtReel/>
        </PortfolioPage>
    )
}

export default TechnicalArtPortfolio;